//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import apiPromotor from "@/api/promotores/usuarios.api";
import apiVerificar from "@/api/promotores/usuarios/verificaciones.api";
import Modulos from '@/api/promotores/usuarios/modulos.api';
import MatiVerificacion from "../../promotor/verificaciones/MatiVerificacion.vue";


const baseUrl = process.env.VUE_APP_ITELLIGENTIAL;
export default {
    components: { MatiVerificacion },
    data() {
        return {
            promotor: {},
            baseUrl,
            verify: {},
            verificacion: {},
            tab: 'intelligential'
        }
    },
    mounted() {
        this.loadPromotor();
        this.loadVerificaciones();
        this.loadVerificacion();
    },
    methods: {
        async loadPromotor() {
            this.promotor = await apiPromotor.get(this.$route.params.promotor);
        },
        openIntelligential() {
            window.open(`${this.baseUrl}/${this.promotor.email}`)
        },
        async loadVerificacion() {
            this.verificacion = await apiVerificar.verificacion(this.$route.params.promotor);
        },
        async loadVerificaciones() {
            this.verify = await apiVerificar.verificaciones(this.$route.params.promotor);
        },
        solicitarVerificacion() {
            this.$q.dialog({
                title: `Mensaje importante`,
                message: `Al solicitar una nueva solicitud de identidad, enviarás nuevamente 
                el correo electrónico de verificación. <br/>
                <strong> Estas de acuerdo . </strong>`,
                cancel: true,
                html: true,
            }).onOk(async () => {
                await apiVerificar.enviar(this.$route.params.promotor);
                this.$q.dialog({
                    title: `Éxito`,
                    message: `Enviaste correctamente el correo electrónico de verificación al correo <br/>
                    <strong> ${this.promotor.email} </strong>`,
                    cancel: true,
                    html: true,
                });
                this.loadVerificaciones();
                this.loadVerificacion();
            })
        },
        verificar() {
            this.$q.dialog({
                title: "Mensaje importante",
                message: ` Verificación manual <br/>
                    ¿Seguro que quieres verificar al promotor?
                    `,
                html: true,
                cancel: true,
            })
                .onOk(async () => {
                    await Modulos.resolve(this.$route.params.promotor, 'mati')
                    window.location.reload();
                })
        }
    }
}
